export const TitleI18nKey: { [key: string]: string } = {
  "/pricing": "PAGE_PRICING_TITLE",
};

export const DescI18nKey: { [key: string]: string } = {
  "/pricing": "PAGE_PRICING_DESC",
};
